import { combineReducers } from 'redux-immutable'
import reportHeadcountReducer from './report-headcount-get-reducer'
import reportYearOfServiceReducer from './report-year-of-service-get-reducer'
import reportLeaveHistoryReducer from './report-leave-history-get-reducer'
import reportActiveUsersReducer from './report-active-users-get-reducer'
import reportYearOfServiceExportReducer from './report-year-of-service-export-reducer'
import reportHeadcountExportReducer from './report-headcount-export-reducer'
import reportLeaveHistoryExportReducer from './report-leave-history-export-reducer'
import reportActiveUsersExportReducer from './report-active-users-export-reducer'
import reportAuditLogsExportReducer from './report-audit-logs-export-reducer'
import reportSubcontractExportReducer from './report-subcontract-export-reducer'
import reportCompensateExportReducer from './report-compensate-export-reducer'
import reportCompensateGetReducer from './report-compensate-get-reducer'
import reportLeaveGenerationGetReducer from './report-leave-generation-get-reducer'
import reportSubcontractGetReducer from './report-subcontract-get-reducer'
import reportCompensateCancelReducer from './report-compensate-work-cancel-reducer'

export default combineReducers({
  reportHeadcount: reportHeadcountReducer,
  reportYearOfService: reportYearOfServiceReducer,
  reportLeaveHistory: reportLeaveHistoryReducer,
  reportActiveUsers: reportActiveUsersReducer,
  reportYearOfServiceExport: reportYearOfServiceExportReducer,
  reportHeadcountExport: reportHeadcountExportReducer,
  reportLeaveHistoryExport: reportLeaveHistoryExportReducer,
  reportActiveUsersExport: reportActiveUsersExportReducer,
  reportAuditLogsExport: reportAuditLogsExportReducer,
  reportSubcontractExport: reportSubcontractExportReducer,
  reportCompensateExport: reportCompensateExportReducer,
  reportCompensateGet: reportCompensateGetReducer,
  reportLeaveGenerationGet: reportLeaveGenerationGetReducer,
  reportSubcontractGet: reportSubcontractGetReducer,
  reportCompensateCancel: reportCompensateCancelReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/report/index.js